
class LedgerRestAdapter {
  constructor ({agaveAdapter, logger}) {
    this.adapter = agaveAdapter
    this.logger = logger
  }

  async getOne (id, opts = {includeShipments: false, includeOrders: false, programId: null}) {
    const { includeShipments, includeOrders, programId } = opts
    return this.adapter.get('ledger/get_by_location_id', {
      locationId: id,
      includeShipments,
      includeOrders,
      programId
    })
  }

  async getLocationSkuHistory (locationId, productId) {
    return this.adapter.get('ledger/get-location-sku-history', {locationId, productId})
  }

  async getSkuReservations (locationId, productId) {
    return this.adapter.get('ledger/get-sku-reservations', {locationId, productId})
  }

  async calculateLocationLedger (locationUuid, date = new Date().toJSON(), formatLedger = true) {
    return this.adapter.get('ledger/calculate-location-ledger', {locationUuid, date, formatLedger})
  }
}

module.exports = { LedgerRestAdapter }
